import { Tab } from "rizzui";
import LoginActivityTable from "@/app/app-shared/login-activity/table";
import IPTrackingTable from "@/app/app-shared/ip-tracking/table";

export interface LoginActivityPageProps {}

export default function LoginActivityPage(props: LoginActivityPageProps) {
  return (
    <Tab>
      <Tab.List>
        <Tab.ListItem>Login activities</Tab.ListItem>
        <Tab.ListItem>IP Tracking</Tab.ListItem>
      </Tab.List>
      <Tab.Panels className="mt-4">
        <Tab.Panel>
          <LoginActivityTable />
        </Tab.Panel>
        <Tab.Panel>
          <IPTrackingTable />
        </Tab.Panel>
      </Tab.Panels>
    </Tab>
  );
}
